import React from 'react';

import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { Trans } from 'react-i18next';
import { IconCompetencySolid } from '@pegasus/workforce-icons';
import { Button, Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { individualState } from 'state/individual/individual-state';
import { FullScreenModal } from 'components/shared/FullScreenModal/FullScreenModal';
import { LoadingSpinner } from 'components/shared/LoadingSpinner/LoadingSpinner';

import './styles.scss';

export const CreateWorkerSuccess = () => {
    const {t} = useTranslation();

    const newWorker = useRecoilValue(individualState);

    return (
        <FullScreenModal close={false}>
            {newWorker?.id ? (
                <div className="d-flex flex-column justify-content-center align-items-center">
                    <IconCompetencySolid className="CreateWorkerSuccess__checked-img text-success"/>
                    <h1 className="FullScreenModal__title">
                        {t('CreateWorkerSuccess.registrationSuccessful', 'Registration Successful')}
                    </h1>
                    <div className="CreateWorkerSuccess__description">
                        <p className="CreateWorkerSuccess__description-text text-center">
                            {/*<Trans i18nKey="CreateWorkerSuccess.description">*/}
                            {/*    You have successfully registered for an Individual Disability Skills Passport Worker*/}
                            {/*    Profile. We have sent an email to {{workerEmail: newWorker?.email}} with your login*/}
                            {/*    instructions. Please open the email to log in to your Disability Skills Passport*/}
                            {/*    profile. Please wait a few minutes and check your junk folder if you have not received*/}
                            {/*    the email.*/}
                            {/*</Trans>*/}
                            <Trans i18nKey="CreateWorkerSuccess.descriptionPayment">
                                You have successfully registered for an Individual Disability Skills Passport Worker
                                Profile. Please complete the payment to finish your registration.
                            </Trans>
                        </p>
                    </div>
                    <div className="CreateWorkerSuccess__buttons">
                        {/*<Button*/}
                        {/*    variant="primary"*/}
                        {/*    href="https://dsp.poweredbyonsite.com/account?ReturnUrl=%2F#/login"*/}
                        {/*    className="btn-xl CreateWorkerSuccess__button"*/}
                        {/*>*/}
                        {/*    {t('CreateWorkerSuccess.actions.login', 'Log In')}*/}
                        {/*</Button>*/}
                        <Button
                            variant="primary"
                            as={Link}
                            to={`/payment?portal=76&company=138&employee=${newWorker?.id}`}
                            className="btn-xl CreateWorkerSuccess__button"
                        >
                            {t('CreateWorkerSuccess.actions.continueToPayment', 'Continue to Payment')}
                        </Button>
                    </div>
                    <div className="CreateWorkerSuccess__logoDiv">
                        <Image src="/assets/images/DSP-Logo.svg" className="CreateWorkerSuccess__logo"/>
                    </div>
                    <div className="CreateWorkerSuccess__needHelp">
                        {t('CreateWorkerSuccess.needHelp', 'Need Help? Call Support on 1300 192 365')}
                    </div>
                </div>
            ) : (
                <LoadingSpinner/>
            )}
        </FullScreenModal>
    );
};
